import * as React from "react";
const SvgMinus = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 2" {...props}><path d="M15.122 1.667H.833A.833.833 0 1 1 .833 0h14.29a.833.833 0 1 1 0 1.667Z" clipRule="evenodd" /></svg>;
export default SvgMinus;